import { logError } from '@/shared/lib/logging';

export function setItem<T>(key: string, value: T): void {
    try {
        const serialized = JSON.stringify(value);

        localStorage.setItem(key, serialized);
    } catch (error) {
        logError('Failed to save to localStorage', error);
    }
}

export function getItem<T>(key: string, fallback: T): T {
    try {
        const item = localStorage.getItem(key);

        if (item === null) {
            return fallback;
        }

        return JSON.parse(item) as T;
    } catch (error) {
        logError('Failed to read from localStorage', error);

        return fallback;
    }
}

export function removeItem(key: string): void {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        logError('Failed to remove from localStorage', error);
    }
}
